import { model, attr } from 'services/model'
import * as yup from 'yup'

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .typeError('Field name has wrong type')
    .default(null)
    .nullable(),
  value: yup
    .string()
    .typeError('Field value has wrong type')
    .default(null)
    .nullable()
})

const NewsCategory = model(
  'newsCategory',
  {
    name: attr('string'),
    value: attr('string')
  },
  validationSchema
)

export default NewsCategory
